/** Display formatting. Raw units stay bigint until here; nothing is converted to dollars. */
export function units(v: bigint, decimals: number, dp = 2): string {
  const neg = v < 0n;
  const a = neg ? -v : v;
  const base = 10n ** BigInt(decimals);
  const whole = a / base;
  let frac = '';
  if (dp > 0) {
    const f = ((a % base) * 10n ** BigInt(dp)) / base;
    frac = '.' + f.toString().padStart(dp, '0');
  }
  return `${neg ? '−' : ''}${whole.toLocaleString('en-US')}${frac}`;
}

export function compact(v: bigint, decimals: number): string {
  const n = Number(v) / 10 ** decimals;
  const a = Math.abs(n);
  const s = a >= 1e9 ? `${(n / 1e9).toFixed(2)}B` : a >= 1e6 ? `${(n / 1e6).toFixed(2)}M` : a >= 1e3 ? `${(n / 1e3).toFixed(1)}K` : n.toFixed(a < 1 ? 4 : 2);
  return s.replace('-', '−');
}

export function short(addr: string | null | undefined): string {
  if (!addr) return '—';
  // The demo has no contracts or transactions: never dress a zero placeholder up as an address or hash.
  if (/^0x0+$/.test(addr)) return 'demo (none)';
  return `${addr.slice(0, 6)}…${addr.slice(-4)}`;
}

export function secs(n: number): string {
  const s = Math.max(0, Math.ceil(n));
  const m = Math.floor(s / 60);
  return `${m}:${String(s % 60).padStart(2, '0')}`;
}

export function pct(ppm: number, dp = 1): string {
  return `${(ppm / 10_000).toFixed(dp)}%`;
}

export function parseUnits(text: string, decimals: number): bigint | null {
  const t = text.trim();
  if (!/^\d*(\.\d*)?$/.test(t) || t === '' || t === '.') return null;
  const [w, f = ''] = t.split('.');
  if (f.length > decimals) return null;
  return BigInt(w || '0') * 10n ** BigInt(decimals) + BigInt((f + '0'.repeat(decimals)).slice(0, decimals) || '0');
}
